(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noon-space-menu"] && !Shopify.designMode) return;
  try {
    function connectSpaceMenus(root) {
    root.querySelectorAll('.noon-space-nav details').forEach((menu) => {
      if (menu.dataset.connected) return;
      menu.dataset.connected = 'true';
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && menu.closest('.noon-space-nav--desktop')) menu.open = true;
      });
      menu.addEventListener('pointerleave', () => {
        if (menu.closest('.noon-space-nav--desktop') && !menu.contains(document.activeElement)) menu.open = false;
      });
      menu.addEventListener('focusout', (event) => {
        if (menu.closest('.noon-space-nav--desktop') && !menu.contains(event.relatedTarget)) menu.open = false;
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
          event.stopPropagation();
        }
      });
    });
  }
  connectSpaceMenus(document);
  document.addEventListener('shopify:section:load', (event) => connectSpaceMenus(event.target));
  } catch(e) { console.error(e); }
})();

})();
